import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import type { FC } from 'react';
import { type OptionProps, components } from 'react-select';

interface OptionValue {
  value: string;
  label: string;
  description: string;
}

export const RolesSelectOption: FC<OptionProps<OptionValue>> = (props) => {
  return (
    <components.Option {...props}>
      <div className='flex items-center justify-between'>
        {props.data.label}
        {props.data.description && (
          <TooltipIcon
            content={props.data.description}
            iconProps={{
              iconStyle: 'solid',
              inline: true,
            }}
            size='sm'
            className='ml-2'
          />
        )}
      </div>
    </components.Option>
  );
};
